import { AxiosInstance, AxiosResponse } from "axios";
import IntegrationModel from "@/models/IntegrationModel";
import Shared from "@/common/shared";
import APIKeyModel from "@/models/APIKeyModel";

export default class IntegrationService {
  private axiosInstance: AxiosInstance;

  public constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  public async getIntegrations(): Promise<IntegrationModel[]> {
    const url = `/CompanyIntegration/list`;
    const res: AxiosResponse<IntegrationModel[]> = await this.axiosInstance.get<IntegrationModel[]>(url);
    return res.data;
  }

  public async createIntegration(integration: IntegrationModel): Promise<IntegrationModel> {
    const url = `/CompanyIntegration`;
    const res: AxiosResponse<IntegrationModel> = await this.axiosInstance.post<IntegrationModel>(url, integration);
    return res.data;
  }

  public async authorizeIntegration(integrationId: number): Promise<string> {
    const url = `/CompanyIntegration/authorize/${integrationId}`;
    const res: AxiosResponse<string> = await this.axiosInstance.get<string>(url);
    return res.data;
  }

  public async activateIntegration(integrationId: string, code: string): Promise<string> {
    const url = `/CompanyIntegration/activate/${integrationId}?code=${encodeURIComponent(code)}`;
    const res: AxiosResponse<string> = await this.axiosInstance.post<string>(url);
    return res.data;
  }

  public async disableIntegration(integrationId: number): Promise<boolean> {
    const url = `/CompanyIntegration/disable/${integrationId}`;
    const res: AxiosResponse<boolean> = await this.axiosInstance.delete<boolean>(url);
    return res.data;
  }

  public async getApiKeys(): Promise<APIKeyModel[]> {
    const url = `/CompanyIntegration/apikeytypes`;
    const res: AxiosResponse<APIKeyModel[]> = await this.axiosInstance.get<APIKeyModel[]>(url);
    return res.data;
  }

  public async refreshApiKey(id: number): Promise<string> {
    const url = `/CompanyIntegration/refresh-key/${id}`;
    const res: AxiosResponse<string> = await this.axiosInstance.get<string>(url);
    if (res.status === 404) {
      const customError = new Error();
      customError.name = Shared.notFound;
      return Promise.reject(customError);
    }
    return res.data;
  }
}
